<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/alto-wine-estate')">Alto Wine
                        Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer')">Kanonkop
                        Paul Sauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/meerlust-estate')">Meerlust Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/savanha-wines')">Savanha Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/the-sadie-family-wines')">The
                        Sadie Family Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards')">
                        Thelema Mountain Vineyards
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Tenuta Meerlust</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avventure all'aria aperta, segno di spunta. Scenario drammatico, segno di spunta. Cinque grandi safari... tick, tick tick. Sud
                        L'Africa può essere una terra di superlativi naturali, ma ciò che molte persone sono ancora all'oscuro quando
                        arriva ai loro vini pregiati? Le regioni vinicole sudafricane, note anche come Winelands, lo sono
                        alcune delle regioni vinicole più belle del mondo, che producono Pinotage e Cabernet di altissimo livello
                        Sauvignon, Merlot e Cabernet Franc.
                    </div>

                    <div class="howto-title2">Meerlust, mein future</div>
                    <div class="howto-text">
                        La tenuta Meerlust non fa eccezione. La tenuta Stellenbosch di 400 ettari è stata fondata nel XVIII
                        secolo (1756 per l'esattezza) e ha la più lunga tradizione familiare in Sud Africa. Oggi è il
                        tocca a Hannes Myburgh, ottava generazione, prendersi cura dei beni di famiglia. Nominato da A
                        precedente proprietario tedesco, Meerlust ha una traduzione letterale di "desiderio di mare" o "febbre di mare" e
                        la vicinanza della tenuta all'oceano non è affatto una coincidenza. I venti marittimi trattengono l'uva
                        fresco durante i mesi invernali più caldi, mentre il terreno granitico costringe le viti a scavare
                        profondo, che si traduce in uve che maturano più lentamente, con un corpo più pieno e una maggiore complessità
                        stivale.
                    </div>

                    <div class="howto-title2">Terra sudafricana, stile italiano</div>
                    <div class="howto-text">
                        Meerlust era relativamente sotto il radar prima del 1960, producendo il tradizionale vino dolce da dessert del Sud Africa dell'epoca. Questo fino a quando non è intervenuto il capo enologo Giorgio dalla Cia con la sua eredità italiana e il senso del tradizionalismo. Ripiantando gran parte della tenuta con cabernet sauvignon, merlot, cabernet franc e pinot nero, Giorgio ha portato uno stile di gestione del vigneto europeo trama per trama, qualcosa che all'epoca era inaudito in Sud Africa. Sotto l'attenta guida di dalla Cia, Meerlust divenne nota come una delle aziende vinicole più importanti del Sud Africa. La tenuta ha prodotto Rubicon a base di Cabernet Sauvignon (così chiamato perché ha segnato un cambiamento nella storia) così come gli imbottigliamenti varietali di Merlot, Pinot Noir e Chardonnay. Questi sono stati realizzati in uno stile "vecchio mondo" molto particolare e hanno spinto Meeerlust in cima alle liste dei collezionisti. Dalla Cia è stato sostituito da Chris Williams nel 2003, che aveva perfezionato la produzione di vini dallo stile moderno a Delaire prima di entrare in carica presso Meerlust.
                    </div>

                    <div class="howto-title2">Esporta e ROI</div>
                    <div class="howto-text">
                        Meerlust produce 25.000 casse di vino all'anno, di cui 2.000 vengono esportate negli Stati Uniti.
                        Il Rubicon viene prodotto solo nelle annate migliori e, ad oggi, sono state prodotte solo 18 annate
                        prodotto. Come molti vini pregiati sudafricani, rappresenta un eccezionale rapporto qualità-prezzo - pensa
                        solo circa € 60 per il 2016 da 91 punti. Il potenziale di invecchiamento è buono, le aspettative sono almeno
                        ROI di 10 anni.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Meerlust Estate</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Outdoor-Abenteuer, ankreuzen. Dramatische Szenerie, tick. Big Five Safaris … tick, tick tick. Süd
                        Afrika mag ein Land der natürlichen Superlative sein, doch viele Menschen tappen noch immer im Dunkeln
                        kommt zu ihren erlesenen Weinen? Die südafrikanischen Weinregionen – auch Winelands genannt – sind
                        Einige der schönsten Weinregionen der Welt produzieren erstklassigen Pinotage und Cabernet
                        Sauvignon, Merlot und Cabernet Franc.
                    </div>

                    <div class="howto-title2">Meerlust, meine Zukunft</div>
                    <div class="howto-text">
                        Das Meerlust-Anwesen ist keine Ausnahme. Das 400 Hektar große Anwesen in Stellenbosch wurde im 18. Jahrhundert gegründet
                        Jahrhundert (genauer gesagt 1756) und hat die längste Familientradition in Südafrika. Heute ist es das
                        Hannes Myburgh, achte Generation, ist an der Reihe und kümmert sich um den Familienbesitz. Benannt von a
                        Der frühere deutsche Besitzer Meerlust hat eine wörtliche Übersetzung von „Seesehnsucht“ oder „Seefieber“ und
                        Die Nähe des Anwesens zum Meer ist kein Zufall. Meereswinde halten die Trauben fest
                        In den heißeren Wintermonaten ist es kühl, während der Granitboden dafür sorgt, dass die Reben umgegraben werden müssen
                        tief, was zu langsamer reifenden Trauben mit einem volleren Körper und größerer Komplexität führt
                        Stiefel.
                    </div>

                    <div class="howto-title2">Südafrikanischer Boden im italienischen Stil</div>
                    <div class="howto-text">
                        Meerlust war vor 1960 relativ unbekannt und produzierte damals den traditionellen süßen Dessertwein Südafrikas. Bis Chefwinzer Giorgio dalla Cia mit seinem italienischen Erbe und seinem Sinn für Traditionalismus eingriff. Er bepflanzte einen Großteil des Anwesens mit Cabernet Sauvignon, Merlot, Cabernet Franc und Pinot Noir und führte einen europäischen Parzellen-Weinbergbewirtschaftungsstil ein, etwas, das zu dieser Zeit in Südafrika unbekannt war. Unter der sorgfältigen Führung von dalla Cia wurde Meerlust zu einem der bedeutendsten Weingüter Südafrikas. Das Weingut produzierte die auf Cabernet Sauvignon basierende Mischung Rubicon (so genannt, weil sie eine Wende in der Geschichte darstellte) sowie die Sortenabfüllungen von Merlot, Pinot Noir und Chardonnay. Diese wurden in einem sehr charakteristischen Stil der „alten Welt“ hergestellt und brachten Meeerlust an die Spitze der Sammlerlisten. Dalla Cia wurde 2003 durch Chris Williams ersetzt, der die Herstellung moderner Weine bei Delaire perfektioniert hatte, bevor er seine Anstellung bei Meerlust antrat.
                    </div>

                    <div class="howto-title2">Export und ROI</div>
                    <div class="howto-text">
                        Meerlust produziert jährlich 25.000 Kisten Wein, von denen 2.000 in die USA exportiert werden.
                        Rubicon wird nur in den allerbesten Jahrgängen hergestellt und bisher gab es nur 18 Jahrgänge
                        produziert. Wie viele erlesene südafrikanische Weine bietet er ein außergewöhnliches Preis-Leistungs-Verhältnis
                        knapp 60 € für den 91-Zeiger 2016. Das Alterungspotenzial ist gut, die Erwartungen zumindest
                        10 Jahre ROI.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Domaine Meerlust</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Aventures en plein air, cochez. Paysage dramatique, cochez. Cinq grands safaris… tic, tic tic. Sud
                        L'Afrique est peut-être une terre de superlatifs naturels, mais ce que beaucoup de gens ignorent encore quand il
                        vient à leurs vins fins? Les régions viticoles sud-africaines - également connues sous le nom de Winelands - sont
                        certaines des plus belles régions viticoles du monde, produisant du Pinotage de haut niveau, du Cabernet
                        Sauvignon, Merlot et Cabernet Franc.
                    </div>

                    <div class="howto-title2">Meerlust, mein future</div>
                    <div class="howto-text">
                        Le domaine Meerlust ne fait pas exception. Le domaine de 400 hectares de Stellenbosch a été fondé au 18e
                        siècle (1756 pour être exact) et a la plus longue tradition familiale en Afrique du Sud. Aujourd'hui c'est le
                        tour de Hannes Myburgh, huitième génération, de s'occuper de la propriété familiale. Nommé par un
                        ancien propriétaire allemand, Meerlust a une traduction littérale de « envie de mer » ou « fièvre de la mer » et
                        la proximité du domaine avec l'océan n'est en aucun cas une coïncidence. Les vents maritimes gardent les raisins
                        frais pendant les mois d'hiver les plus chauds, tandis que le sol granitique oblige les vignes à creuser
                        profond, résultant en des raisins qui mûrissent plus lentement, avec un corps plus plein et une plus grande complexité à
                        botte.
                    </div>

                    <div class="howto-title2">Sol sud-africain, style italien</div>
                    <div class="howto-text">
                        Meerlust était relativement sous le radar avant 1960, produisant le vin de dessert sucré traditionnel de l'Afrique du Sud de l'époque. C'était jusqu'à ce que le vigneron en chef Giorgio dalla Cia avec son héritage italien et son sens du traditionalisme intervienne. Replantant une grande partie du domaine avec du cabernet sauvignon, du merlot, du cabernet franc et du pinot noir, Giorgio a apporté un style européen de gestion des vignobles parcelle par parcelle, quelque chose qui était inouï en Afrique du Sud à l'époque. Sous la direction prudente de dalla Cia, Meerlust est devenu l'un des vignobles les plus importants d'Afrique du Sud. Le domaine a produit l'assemblage Rubicon à base de Cabernet Sauvignon (appelé ainsi car il a marqué un tournant dans l'histoire) ainsi que les embouteillages variétaux de Merlot, Pinot Noir et Chardonnay. Ceux-ci ont été fabriqués dans un style «vieux monde» très distinctif et ont propulsé Meeerlust au sommet des listes de collectionneurs. Dalla Cia a été remplacé par Chris Williams en 2003 qui avait perfectionné la production de vins de style moderne chez Delaire avant de prendre ses fonctions chez Meerlust.
                    </div>

                    <div class="howto-title2">Exportation et retour sur investissement</div>
                    <div class="howto-text">
                        Meerlust produit 25 000 caisses de vin par an, dont 2 000 sont exportées aux États-Unis.
                        Rubicon n'est fabriqué que dans les meilleures années, et à ce jour, il n'y a eu que 18 millésimes
                        produit. Comme beaucoup de vins fins sud-africains, il représente un rapport qualité-prix exceptionnel - pensez
                        juste autour de 60 € pour le 91 points 2016. Le potentiel de garde est bon, les attentes sont au moins
                        RCI sur 10 ans.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Meerlust Estate</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Outdoor adventures, tick. Dramatic scenery, tick. Big five safaris … tick, tick tick. South
                        Africa may be a land of natural superlatives, but what many people are still in the dark when it
                        comes to their fine wines? The South African wine regions - also known as the Winelands - are
                        some of the most beautiful wine regions in the world, producing top-level Pinotage, Cabernet
                        Sauvignon, Merlot and Cabernet Franc.
                    </div>

                    <div class="howto-title2">Meerlust, mein future</div>
                    <div class="howto-text">
                        The Meerlust estate is no exception. The 400-hectare Stellenbosch estate was founded in the 18th
                        century (1756 to be exact) and has the longest family tradition in South Africa. Today it is the
                        turn of Hannes Myburgh, eighth generation, to look after the family property. Named by a
                        previous German owner, Meerlust has a literal translation of “sea longing” or “sea fever” and
                        the estate’s proximity to the ocean is by no means a coincidence. Maritime winds keep the grapes
                        cool during the hotter winter months, while the granite soil means the vines have to dig down
                        deep, resulting in grapes that ripen more slowly, with a fuller body and greater complexity to
                        boot.
                    </div>

                    <div class="howto-title2">South African soil, Italian style</div>
                    <div class="howto-text">
                        Meerlust was relatively under the radar pre-1960, producing the traditional sweet dessert wine of South Africa of the time. That was until head winemaker Giorgio dalla Cia with his Italian heritage and sense of traditionalism stepped in. Replanting much of the estate with cabernet sauvignon, merlot, cabernet franc and pinot noir, Giorgio brought a European plot-by-plot vineyard management style, something that was unheard of in South Africa at the time. Under dalla Cia’s careful steerage, Meerlust became known as one of South Africa&#39;s most prominent wineries. The estate produced Cabernet Sauvignon-based blend Rubicon (so-called as it marked a change in history) as well as the varietal bottlings of Merlot, Pinot Noir and Chardonnay. These were made in a very distinctive “old-world” style, and propelled Meeerlust to the top of collector’s lists. Dalla Cia was replaced by Chris Williams in 2003 who had perfected producing modern style wines at Delaire prior to taking up tenure at Meerlust.
                    </div>

                    <div class="howto-title2">Export and ROI</div>
                    <div class="howto-text">
                        Meerlust produces 25,000 cases of wine a year, of which 2,000 are exported to the United States.
                        Rubicon is made only in the very best years, and to date, there have only been 18 vintages
                        produced. Like many South African fine wines, it represents exceptional value for money - think
                        just around €60 for the 91-pointer 2016. Ageing potential is good, expectations are at least
                        10-years ROI.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MeerlustEstate",
    data() {
        return {
            select: {report: 'Meerlust Estate', src: '/wine-guide/south-africa/stellenbosch/meerlust-estate'},
            items: [
                {report: 'Alto Wine Estate', src: '/wine-guide/south-africa/stellenbosch/alto-wine-estate'},
                {report: 'Kanonkop Paul Sauer', src: '/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer'},
                {report: 'Meerlust Estate', src: '/wine-guide/south-africa/stellenbosch/meerlust-estate'},
                {report: 'Savanha Wines', src: '/wine-guide/south-africa/stellenbosch/savanha-wines'},
                {report: 'The Sadie Family Wines', src: '/wine-guide/south-africa/stellenbosch/the-sadie-family-wines'},
                {
                    report: 'Thelema Mountain Vineyards',
                    src: '/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Meerlust Estate | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Meerlust Estate, a renowned South African wine producer in the Stellenbosch region. Savor the unique blends and traditional winemaking methods of this top-rated winery. Experience the rich flavor and history of Meerlust Estate\'s premium wines today.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
